import styled from 'styled-components';
import theme from 'components/theme';
import { mediaDesktop } from 'breakpoints';
import Typography from 'components/Typography';
import { StyledCardFixedWrapper } from 'components/Card/styled';
import { PackRarity } from 'global/constants';

import CommonCover from 'static/reward-frames/common/img-common-plus-empty@3x.png';
import LegendaryCover from 'static/reward-frames/legendary/img-legendary-plus-empty@3x.png';
import RareCover from 'static/reward-frames/rare/img-rare-plus-empty@3x.png';

export const RewardWrapper = styled.div<{ $isPreview?: boolean }>`
  margin: 0 24px;

  ${mediaDesktop} {
    width: 100%;
    margin: 100px auto ${({ $isPreview }) => ($isPreview ? '24px' : 0)};
    max-width: 1180px;
  }
`;

export const RewardHeadline = styled(Typography)`
  margin: 42px 0 12px;
  letter-spacing: 1px;
  text-align: left;

  ${mediaDesktop} {
    margin: 0 0 24px;
    line-height: 48px;
    text-align: center;
    letter-spacing: 2px;
  }
`;

export const RewardDescription = styled.div`
  font-family: ${theme.fonts.primary};
  font-size: 16px;
  letter-spacing: 1px;
  color: #d8d8d8;
  margin: 12px auto;

  ${mediaDesktop} {
    text-align: center;
    margin: 24px auto;
    font-size: 21px;
    max-width: 1000px;
  }
`;

export const RewardDate = styled.div`
  font: 600 16px ${theme.fonts.primary};
  letter-spacing: 1px;
  color: #d8d8d8;
  margin-bottom: 35px;

  ${mediaDesktop} {
    text-align: center;
    font-size: 21px;
    margin-bottom: 28px;
  }
`;

export const RewardCards = styled.div`
  letter-spacing: 1px;

  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 32px 0;

  ${mediaDesktop} {
    margin: auto;
    line-height: 48px;
    text-align: center;
    letter-spacing: 2px;

    padding: 20px 0 14px;

    display: grid;
    grid-template-columns: repeat(auto-fit, 320px);
    max-width: 1100px;

    grid-gap: 53px;
    justify-content: center;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  /* //? Gets cards assets in proper place, why */
  text-align: left;

  ${mediaDesktop} {
    flex-direction: column;
    margin: 0;
  }
`;

export const CardWrapper = styled.div<{ $bottom?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 174px;
  flex-shrink: 0;
  height: 278px;


  & > div:first-child {
    transform: none;
  }

  ${mediaDesktop} {
    display: block;
    height: 516px;
    width: 100%;
    ${({ $bottom }) => $bottom && `
      margin: 0 0 100px;
    `}
  }

  & > div {
    position: relative;
  }
`;

export const CardDescriptionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
  margin: 20px 0 10px 10px;
  text-transform: uppercase;

  ${mediaDesktop} {
    font-size: 24px;
    margin: 32px 32px 5px;
    width: 320px;
  }
`;

export const CardDescriptionText = styled.div`
  font-size: 11px;
  color: #fff;
  margin: 0 0 0 10px;
`;

const frames = {
  [PackRarity.commonPlus]: CommonCover,
  [PackRarity.legendaryPlus]: LegendaryCover,
  [PackRarity.rarePlus]: RareCover,
};

export const UnrevealedCardContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const UnreaveledCardScore = styled.div`
  ${mediaDesktop} {
    margin-top: -15px;
    font-weight: bold;
    font-size: 24px;
  }
`;

export const UnrevealedCardScoreText = styled.div`
  font-family: ${theme.fonts.primary};
  font-size: 16px;
  color: #fff;
  letter-spacing: normal;
  margin-top: 10px;
  margin-left: 10px;
  ${mediaDesktop} {
    margin-top: 18px;
    color: ${theme.colors.textWhite};
    font-size: 21px;
    text-align: center;
  }
`;

export const UnrevealedCard = styled(StyledCardFixedWrapper) <{ rarity: string }>`
  height: 100%;
  width: 100%;
  justify-content: center;

  background-image: url(${({ rarity }) => frames[rarity]});
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  border-radius: inherit;
  padding: 1px;
  cursor: default;
`;

export const CardTextReward = styled.p`
  color: #cccccc;
  pointer-events: none;
  opacity: 0.5;
  font: bold 16px ${theme.fonts.spaceMono}; 
  text-align: center;
  letter-spacing: 1px;
  display: none;

  ${mediaDesktop} {
    display: block;
  }
`;
